const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: `${process.env.REACT_APP_AWS_USER_POOL_ID}`,
      userPoolClientId: `${process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID}`,
      loginWith: {
        oauth: {
          redirectSignIn: [`${process.env.REACT_APP_AWS_LOGIN_REDIRECT_URI}`],
          redirectSignOut: [`${process.env.REACT_APP_AWS_LOGOUT_REDIRECT_URI}`],
          // The user pool's hosted UI domain, from the app stack's outputs.
          domain: `${process.env.REACT_APP_AWS_COGNITO_DOMAIN}`,
          responseType: 'code',
          scopes: ['email', 'openid', 'phone', 'profile'],
        },
      },
    },
  },
  // Storage: {
  // 	AWSS3: {
  // 		bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
  // 		region: `${process.env.REACT_APP_REGION}`,
  // 	},
  // },
};

export default awsconfig;
